import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as service from "./service";
import Translate from "../../../Components/Multilanguage/Translate";
import { useTranslateText } from "../../../Components/Multilanguage/Translate";
const ForgotPassword = () => {
  const [values, setValues] = useState({ email: "" });
  const [errors, setErrors] = useState({});
  const [disableButton, setDisableButton] = useState(false);
  const accessToken = useSelector((state) => state.accessToken?.value);
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const navigate = useNavigate();
  const translateText = useTranslateText();
  const appInfo = {
    accessToken: accessToken,
    projectDetails: projectInfo,
  };
  const theme =projectInfo?.projectConfig?.config?.THEME ;
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
  const handleChange = (item) => {
    const { name, value } = item.target;
    setValues(prev => ({ ...prev, [name]: value }));
    
    // Clear errors when user starts typing
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }));
    }
  };

  const validateEmail = () => {
    let error = {};
    let emailValid = true;
    let emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (!values.email || values.email.trim() === "") {
      error.email = <Translate textKey={'email_required_message'}/>;
      emailValid = false;
    } 
    // else if (!values.email.match(emailRegex)) {
    //   error.email = <Translate textKey={'valid_email_message'}/>;
    //   emailValid = false;
    // }
    setErrors(error);
    return emailValid;
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const emailValid = validateEmail();
      if (emailValid) {  
        setDisableButton(true);
        const response = await service.forgotPasswordEmailVerify(appInfo, values.email);
        if (response?.status === 200) {
          toast.success(response?.data?.message, {
            position: "top-center",
          });
          setDisableButton(false);
        } else {
          toast.error(response?.data?.message, {
            position: "top-center",
          });
          setDisableButton(false);
        }
      } else {
        event.preventDefault();
        return false;
      }
    } catch (err) {
      toast.error(err?.response?.data?.message, {
        position: "top-center",
      });
      setDisableButton(false);
    }
  };
  return (
    <div className="forgotPassword" role="main" aria-label="Forgot Password Page">
      <ToastContainer />
      <div className="wrapper">
        <div className="forgotPasswordContainer" role="region" aria-label="Forgot Password Container">
          <h1 className="heading" id="forgot-password-heading"><Translate textKey={'reset_your_password'}/></h1>
          <div className="formContainer">
            <form action="post" aria-labelledby="forgot-password-heading" aria-label="Forgot Password Form">
              <input
                type="email"
                placeholder="Enter registered Email ID"
                name="email"
                value={values.email}
                onChange={(item) => {
                  handleChange(item);
                }}
                onBlur={validateEmail}
                aria-label="Email Address"
              />
              {errors.email && <span className="error">{errors.email}</span>}

              <button 
                type="submit" 
                className={`buttonContainer ${theme === 'LIGHT' ? 'light-theme' : ''}`}
                onClick={(event) => {
                  handleSubmit(event);
                }}
                aria-label="Submit Forgot Password"
                disabled={disableButton}
              >
                <Translate textKey={'submit'}/>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
